import { Box, Card, Flex, HStack, VStack } from '@televet/kibble-ui';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Tag } from '@televet/kibble-ui/build/components/Tag';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { default as React } from 'react';
import { AttachmentFormData } from '../types/AttachmentFormData';

type FormListItemProps = {
  formData: AttachmentFormData;
  onClick: () => void;
};

export const FormListItem = ({ formData, onClick }: FormListItemProps): JSX.Element => {
  return (
    <Card mb={4} p={0} onClick={onClick} isInteractive={true}>
      <HStack p={3} spacing={2} alignItems="flex-start" justify="space-between" align="baseline">
        <Icon name="form" size="lg" />
        <VStack justify="center" align="left" spacing={0} flexGrow={1}>
          <Box mb={2} mt={1}>
            <Heading size="xs" mb={1}>
              {formData.title}
            </Heading>
            <Text size="sm" variant="subtle">
              Sent on: {formData.createdAt}
            </Text>
          </Box>
          <Flex gap={2}>
            <Tag
              label={formData.isCompleted ? 'Completed' : 'Incomplete'}
              variant={formData.isCompleted ? 'success' : 'warning'}
              size="sm"
            />
          </Flex>
        </VStack>
      </HStack>
    </Card>
  );
};
